module.exports = __webpack_public_path__ + "static/media/holiday-wreath.15f2af8a.png";